// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__3IAOI","title":"Widget_title__2ud5x"};